<template>
    <div>
        <div v-if="errors.length" class="py-4 px-6 bg-red text-white mb-4">
            <ul class="mb-0" :class="{
                'pl-5': errors.length > 1,
                'list-none p-0': errors.length === 1,
            }">
                <li v-for="error in errors" :key="error" v-html="error"></li>
            </ul>
        </div>

        <div class="mx-auto w-20 h-20 rounded-full border-4 border-blue-450 overflow-hidden -mb-10 relative z-10">
            <img
                :src="avatar"
                class="block w-full h-full bg-blue-450"
            />
        </div>

        <div class="bg-blue p-6 pt-12">

            <form class="pt-2" method="POST" action="login" novalidate @submit="submit">
                <!-- CSRF -->
                <input type="hidden" name="_token" :value="token" />
                <input v-if="redirect" type="hidden" name="_redirect" :value="redirect" />

                <!-- Blank field start-->
                <div class="hidden" id="blank-id-wrapper">
                    <label>Keep this field blank</label>
                    <input type="text" name="blank-id" id="blank-id" />
                </div>
                <!-- Blank field end -->

                <!-- Username -->
                <div class="form-group mb-4">
                    <label class="sr-only" for="email">Email</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text bg-blue-450 border-blue w-12">
                                <i class="far fa-envelope mx-auto" style="color: #ffffff !important;"></i>
                            </div>
                        </div>
                        <input
                            required
                            autofocus
                            id="email"
                            name="email"
                            type="email"
                            v-model="email"
                            dusk="login-email"
                            placeholder="Email"
                            @blur="updateAvatar"
                            v-on:input="$v.email.$touch"
                            class="form-control p-3 bg-blue-450 border-blue text-white"
                        />
                    </div>
                </div>

                <!-- Password -->
                <div class="form-group mb-8">
                    <label class="sr-only" for="password">Password</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text bg-blue-450 border-blue w-12">
                                <i class="far fa-lock-alt mx-auto" style="color: #ffffff !important;"></i>
                            </div>
                        </div>
                        <input
                            required
                            id="password"
                            name="password"
                            type="password"
                            v-model="password"
                            dusk="login-password"
                            placeholder="Password"
                            v-on:input="$v.password.$touch"
                            class="form-control p-3 bg-blue-450 border-blue text-white"
                        />
                    </div>
                </div>

                <!-- Button -->
                <div class="form-row">
                    <div class="col">
                        <button
                            type="submit"
                            dusk="login-button"
                            class="btn btn-lg btn-block"
                            :class="{
                                'btn-success': canSubmit,
                                'btn-light cursor-not-allowed': cannotSubmit,
                            }"
                        >
                            Login <i v-if="submitting" class="far fa-spinner-third fa-spin"></i>
                        </button>
                        <div class="text-center pt-1">
                            <a href="/password/reset" class="text-white no-underline hover:underline text-sm text-blue-300 font-bold">
                                Forgot your password?
                            </a>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { email, required } from 'vuelidate/lib/validators';

export default {
    props: ['reauth','token','errors', 'redirect'],
    data() {
        return {
            avatar: 'img/avatar.svg',
            email: '',
            submitting: false,
            password:''
        }
    },
    created(){
        if(this.reauth){
            this.email = this.reauth
        }
    },
    validations: {
        email: {required, email},
        password: {required},
    },
    computed:{
        cannotSubmit() {
            return this.$v.$invalid;
        },
        canSubmit() {
            return this.cannotSubmit === false;
        },
    },
    methods:{
        updateAvatar() {
            if(!this.$v.email.$invalid){
                this.getGravatar({email: this.email})
                    .then((response) => {
                        this.avatar = response.data.avatarUrl;
                    })
                    .catch((error) => {
                        this.avatar = 'img/avatar.svg';
                    });
            } else {
                this.avatar = 'img/avatar.svg';
            }
        },

        submit: function (event) {
            if (this.submitting || this.cannotSubmit) {
                event.preventDefault();
                return;
            }

            this.submitting = true;
        },
    }
}
</script>
